/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Teams_In_Different_DivisionsInputs */

const th_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมทั้งสองอยู่คนละดิวิชั่นในอีเวนต์นี้`)
};

const en_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Those two teams are in different divisions of this event.`)
};

const ja_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この2チームは、この大会の異なるディビジョンに所属しています。`)
};

const zh_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这两支球队在本赛事的不同分区。`)
};

const es_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esos dos equipos están en categorías distintas de este evento.`)
};

const pt_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses dois times estão em categorias diferentes deste evento.`)
};

const id_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedua tim itu berada di divisi berbeda pada acara ini.`)
};

const fr_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces deux équipes sont dans des catégories différentes de cet événement.`)
};

const tl_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magkaibang dibisyon ng event na ito ang dalawang team na iyon.`)
};

const vi_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai đội đó nằm ở hai bảng khác nhau của sự kiện này.`)
};

const ko_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 팀은 이 이벤트의 서로 다른 디비전에 있습니다.`)
};

const de_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese beiden Teams sind in unterschiedlichen Klassen dieses Events.`)
};

const ru_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эти две команды в разных дивизионах данного события.`)
};

const tr_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu iki takım bu etkinliğin farklı gruplarında.`)
};

const it_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle due squadre sono in categorie diverse di questo evento.`)
};

const pl_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te dwie drużyny są w różnych grupach tego wydarzenia.`)
};

const uk_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ці дві команди в різних дивізіонах цієї події.`)
};

const hi_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वे दोनों टीमें इस आयोजन के अलग-अलग वर्गों में हैं।`)
};

const ar_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذان الفريقان في فئتين مختلفتين من هذه الفعالية.`)
};

const ms_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedua-dua pasukan itu berada dalam divisyen berbeza acara ini.`)
};

const bn_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই দুই দল এই আয়োজনের ভিন্ন বিভাগে আছে।`)
};

const zh_tw2_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這兩支球隊在本賽事的不同分組。`)
};

const zh_hk2_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這兩支球隊在本賽事的不同組別。`)
};

const ur_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ دونوں ٹیمیں اس ایونٹ کے مختلف درجوں میں ہیں۔`)
};

const fa_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن دو تیم در گروه‌های متفاوتی از این رویداد هستند.`)
};

const sw_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu hizo mbili zipo kwenye madaraja tofauti ya tukio hili.`)
};

const nl_err_teams_in_different_divisions = /** @type {(inputs: Err_Teams_In_Different_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die twee teams zitten in verschillende klassen van dit evenement.`)
};

/**
* | output |
* | --- |
* | "Those two teams are in different divisions of this event." |
*
* @param {Err_Teams_In_Different_DivisionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_teams_in_different_divisions = /** @type {((inputs?: Err_Teams_In_Different_DivisionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Teams_In_Different_DivisionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_teams_in_different_divisions(inputs)
	if (locale === "ja") return ja_err_teams_in_different_divisions(inputs)
	if (locale === "zh") return zh_err_teams_in_different_divisions(inputs)
	if (locale === "es") return es_err_teams_in_different_divisions(inputs)
	if (locale === "pt") return pt_err_teams_in_different_divisions(inputs)
	if (locale === "id") return id_err_teams_in_different_divisions(inputs)
	if (locale === "fr") return fr_err_teams_in_different_divisions(inputs)
	if (locale === "tl") return tl_err_teams_in_different_divisions(inputs)
	if (locale === "vi") return vi_err_teams_in_different_divisions(inputs)
	if (locale === "ko") return ko_err_teams_in_different_divisions(inputs)
	if (locale === "de") return de_err_teams_in_different_divisions(inputs)
	if (locale === "ru") return ru_err_teams_in_different_divisions(inputs)
	if (locale === "tr") return tr_err_teams_in_different_divisions(inputs)
	if (locale === "it") return it_err_teams_in_different_divisions(inputs)
	if (locale === "pl") return pl_err_teams_in_different_divisions(inputs)
	if (locale === "uk") return uk_err_teams_in_different_divisions(inputs)
	if (locale === "hi") return hi_err_teams_in_different_divisions(inputs)
	if (locale === "ar") return ar_err_teams_in_different_divisions(inputs)
	if (locale === "ms") return ms_err_teams_in_different_divisions(inputs)
	if (locale === "bn") return bn_err_teams_in_different_divisions(inputs)
	if (locale === "zh-TW") return zh_tw2_err_teams_in_different_divisions(inputs)
	if (locale === "zh-HK") return zh_hk2_err_teams_in_different_divisions(inputs)
	if (locale === "ur") return ur_err_teams_in_different_divisions(inputs)
	if (locale === "fa") return fa_err_teams_in_different_divisions(inputs)
	if (locale === "sw") return sw_err_teams_in_different_divisions(inputs)
	if (locale === "nl") return nl_err_teams_in_different_divisions(inputs)
	return en_err_teams_in_different_divisions(inputs)
});